/**
 * Property filter types
 *
 * @type {object}
 */
export const propertyFilterTypes = {
  string: 'string',
  number: 'number',
  boolean: 'boolean'
};
export const propertyFilters = {
  [propertyFilterTypes.string]: 'Строка',
  [propertyFilterTypes.number]: 'Число',
  [propertyFilterTypes.boolean]: 'Истина/ложь'
};
/**
 * Property view types
 *
 * @type {object}
 */

export const propertyViewTypes = {
  default: 'default',
  image: 'image',
  color: 'color'
};
export const propertyViews = {
  [propertyViewTypes.default]: 'По умолчанию',
  [propertyViewTypes.image]: 'Картинка',
  [propertyViewTypes.color]: 'Цвет'
};
/**
 * Property view types
 *
 * @type {object}
 */

export const entityTypes = {
  advert: 'advert',
  company: 'company',
  product: 'product',
  service: 'service'
};
export const entityTypesTitles = {
  [entityTypes.advert]: 'Объявление',
  [entityTypes.company]: 'Компания',
  [entityTypes.product]: 'Продукт',
  [entityTypes.service]: 'Услуга'
};